export const env = {
  VITE_API_URL: import.meta.env.VITE_API_URL as string,
  VITE_PLAYER_RELEASE: (import.meta.env.VITE_PLAYER_RELEASE as string | undefined) ?? '0.1.0',
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string | undefined
}
